import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setRoute } from 'stores/Layout/layoutActions';

import './index.scss';
import NavigationTabs from 'components/shared/NavigationTabs';
import Spinner from 'components/shared/Spinner';
import { getPageContent } from 'services/content.service';
class Careers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: null,
      loading: true,
    };
  }
  componentDidMount() {
    this.props.setRoute({ name: 'careers', id: this.props.routeId });
    this.fetchContent();
  }

  fetchContent = () => {
    const slug = this.props.location.pathname.substr(4);
    getPageContent(slug)
      .then((response) => {
        this.setState({
          content: response?.data?.result?.details,
          loading: false,
        });
      })
      .catch((error) => {
        console.error('Error fetching content:', error);
      });
  };
  render() {
    let content = null;
    if (this.state.loading) {
      content = <Spinner />;
    } else {
      content = (
        <div dangerouslySetInnerHTML={{ __html: this.state.content }} />
      );
    }

    return (
      <div className="mainWrapper">
        <NavigationTabs />
        <div className="static-page-container">{content}</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.layout.iso,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ setRoute }, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps)(Careers);
